export default __webpack_public_path__ + "static/media/manage-port.45086063.svg";